var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Path Type",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.pathType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "pathType", $$v)
                                      },
                                      expression: "local.pathType"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Orientation Type",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.orientationType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "orientationType",
                                          $$v
                                        )
                                      },
                                      expression: "local.orientationType"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Duration (sec)",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.duration,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "duration", $$v)
                                      },
                                      expression: "local.duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Waypoints", type: "text" },
                                    model: {
                                      value: _vm.local.waypoints,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "waypoints", $$v)
                                      },
                                      expression: "local.waypoints"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.destinationProximities,
                                      label: "Select Destination Proximity"
                                    },
                                    model: {
                                      value: _vm.local.destinationProximity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "destinationProximity",
                                          $$v
                                        )
                                      },
                                      expression: "local.destinationProximity"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Type of Component")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.local.componentType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local,
                                            "componentType",
                                            $$v
                                          )
                                        },
                                        expression: "local.componentType"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.componentType.threeD,
                                          value: _vm.componentType.threeD
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.componentType.character,
                                          value: _vm.componentType.character
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("h3", [_vm._v("Position of Origin")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension X",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.X,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "X",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.X"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension Y",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.Y,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "Y",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.Y"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Position of Origin Dimension Z",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.positionOfOrigin.Z,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local.positionOfOrigin,
                                          "Z",
                                          $$v
                                        )
                                      },
                                      expression: "local.positionOfOrigin.Z"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Target", type: "text" },
                                    model: {
                                      value: _vm.local.target,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "target", $$v)
                                      },
                                      expression: "local.target"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Rotation (0-360) degrees",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.rotation,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "rotation", $$v)
                                      },
                                      expression: "local.rotation"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.save } },
                    [
                      this.saving
                        ? _c(
                            "v-flex",
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          )
                        : _c("v-flex", [_vm._v("Save")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0a1cb4e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0a1cb4e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addMovement.vue
// module id = null
// module chunks = 